import {
    ADD_NOTICE_TYPE,
    GET_NOTICE_TYPE_LIST,
    NOTICE_TYPE_LIST_RESPONCE,
    EDIT_NOTICE_TYPE,
    EDIT_NOTICE_TYPE_STATUS,
    DELETE_NOTICE_TYPE,
    EDIT_REDUX_STATE,
    DELETE_REDUX_STATE,
    EDIT_STATUS_REDUX_STATE,
    EDIT_SIGN_STATUS_REDUX_STATE
    
} from "./actionTypes";

/**
 * Creates an action object to add a notice.
 * @param {any} data - The data to be added as a notice.
 * @param {string} token - The token associated with the notice.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, payload, success, and failure properties.
 */
export const addNoticeType = (data, success, failure) => {
  return {
    type: ADD_NOTICE_TYPE,
    payload: { data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
  }

/**
 * Returns an action object to get the notice list.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, payload, success, and failure properties.
 */
export const getNoticeTypeList = (data, success, failure) => {
  return {
    type: GET_NOTICE_TYPE_LIST,
    payload: { data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
  }

/**
 * Action creator function that returns an action object for a successful notice list retrieval.
 * @param {any} data - The data received from the API call.
 * @returns {Object} An action object with the type NOTICE_TYPE_LIST_RESPONCE and the payload set to the received data.
 */
export const NoticeTypeListResponce = data => {
  return {
    type: NOTICE_TYPE_LIST_RESPONCE,
    payload: data,
  }
}

/**
 * Action creator function for editing a notice.
 * @param {string} id - The ID of the notice to edit.
 * @param {object} data - The updated data for the notice.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns An action object with the type, payload, success, and failure properties.
 */
export const editNoticeType = (id, data, success, failure) => {
  return {
    type: EDIT_NOTICE_TYPE,
    payload: { id, data},
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Creates an action object for updating the edit status of a notice.
 * @param {string} id - The ID of the notice to update.
 * @param {object} data - The data to update the notice with.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, payload, success, and failure properties.
 */
export const noticeEditTypeStatus = (id, data, success, failure) => {
  return {
    type: EDIT_NOTICE_TYPE_STATUS,
    payload: { id, data},
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Creates an action object for deleting a notice.
 * @param {string} id - The ID of the notice to delete.
 * @param {object} data - Additional data to include in the payload.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, payload, success, and failure properties.
 */
export const noticeTypeDelete = (id, success, failure) => {
  return {
    type: DELETE_NOTICE_TYPE,
    payload: { id },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}


// redux Actions

/**
 * Action creator function for editing the Redux state.
 * @param {any} data - The data to be updated in the Redux state.
 * @returns {object} An action object with the type and payload properties.
 */
export const editReduxState = (data) => {
  return {
    type: EDIT_REDUX_STATE,
    payload: data,
  }
}

export const deleteReduxState = (data) => {
  /**
   * Returns an action object to delete a Redux state.
   * @param {any} data - The data to be included in the payload of the action.
   * @returns {Object} An action object with type DELETE_REDUX_STATE and the provided payload.
   */
  return {
    type: DELETE_REDUX_STATE,
    payload: data,
  } 
}

/**
 * Action creator function to edit the status in the Redux state.
 * @param {any} data - The data to be updated in the Redux state.
 * @returns {object} - An action object with the type and payload.
 */
export const editStatusReduxState = (data) => {
  return {
    type: EDIT_STATUS_REDUX_STATE,
    payload: data,
  }
}

/**
 * Action creator function to edit the sign status in the Redux state.
 * @param {any} data - The data to be updated in the Redux state.
 * @returns {object} - An action object with the type and payload.
 */
export const editSignStatusReduxState = (data) => {
  return {
    type: EDIT_SIGN_STATUS_REDUX_STATE,
    payload: data,
  }
}

